import { useLocation } from "react-router-dom"
import { parseQuery } from "utils/parseQuery"

export const useCurrentId = () => {
  const location = useLocation()

  return parseQuery(location.search).id
}
